import { FaTimes } from '@react-icons/all-files/fa/FaTimes';
import React from 'react';
import { Button } from '@/components/atoms/Button/Button';
import { Drawer } from '@/components/atoms/Drawer/Drawer';
import { Modal } from '@/components/atoms/Modal/Modal';
import { H1 } from '@/components/atoms/Typography/Typography';
import { useIsMobile } from '@/utils/useIsMobile';
import styles from './ModalDrawerDialog.module.scss';

interface LabelsProps {
  ariaLabel: string;
  closeButtonLabel: string;
  submitButtonLabel?: string;
}

interface Props {
  children: React.ReactNode;
  dismissButton?: React.ReactNode;
  heading: React.ReactNode;
  isDismissButtonVisible?: boolean;
  isOpen: boolean;
  labels: LabelsProps;
  onDismiss: () => void;
}

export const ModalDrawerDialog = ({
  children,
  dismissButton,
  heading,
  isDismissButtonVisible = true,
  isOpen,
  labels,
  onDismiss,
}: Props) => {
  const isMobile = useIsMobile({ includeTablet: false });

  const cta = isDismissButtonVisible
    ? dismissButton || (
        <Button
          color="secondary"
          variant="contained"
          fullWidth
          onClick={onDismiss}
        >
          {labels.submitButtonLabel}
        </Button>
      )
    : null;

  if (!isMobile) {
    return (
      <Modal
        isOpen={isOpen}
        ariaLabel={labels.ariaLabel}
        closeButtonAriaLabel={labels.closeButtonLabel}
        title={heading}
        actions={cta}
        onDismiss={onDismiss}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Drawer
      animateFrom="left"
      ariaLabel={labels.ariaLabel}
      className={styles.drawer}
      isOpen={isOpen}
      onDismiss={onDismiss}
    >
      <Button
        className={styles.drawerCrossBtn}
        onClick={onDismiss}
        variant="icon"
        color="default"
        aria-label={labels.closeButtonLabel}
      >
        <FaTimes size="24px" />
      </Button>
      <H1 version="level4">{heading}</H1>
      <div className={styles.drawerContentWrapper}>
        <div className="modalContent">{children}</div>
        <div className="modalContentGradient" />
      </div>
      {cta}
    </Drawer>
  );
};
